module.exports = __webpack_public_path__ + "static/media/b_icon_02.b919cb7a.png";